import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import ShareButtons from 'hb-react/shared/components/ShareButtons';

import PublicationDate from './PublicationDate';

const PublicationTitle = ({
  publishedAt,
  shareButtonLabel,
  sharingUrl,
  shareAmplitudeEvent,
  title,
  titleAs,
  socialMediaList = [],
}) => {
  const renderSocialMediaList = socialMediaList.length > 0;

  return (
    <Box flexDirection="column" justifyContent="space-between">
      <TitleStyled as={titleAs}>{title}</TitleStyled>
      <PublicationDate publishedAt={publishedAt} />
      {sharingUrl && renderSocialMediaList && (
        <Box display="block" mt={3}>
          <ShareButtons
            selected={socialMediaList}
            shareButtonLabel={shareButtonLabel}
            shareAmplitudeEvent={shareAmplitudeEvent}
            title={title}
            url={sharingUrl}
          />
        </Box>
      )}
    </Box>
  );
};

export default PublicationTitle;

const TitleStyled = styled(Box).attrs({
  font: 'h1-semibold',
  mb: {
    l: 1,
  },
  display: 'block',
})``;
